import React from 'react'
import AddStockLabelledUnlabelled from './AddStockLabelledUnlabelled'

const CreateStockLabelledUnlabelled = () => {
  return (
    <AddStockLabelledUnlabelled/>
  )
}

export default CreateStockLabelledUnlabelled
